import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { FaWindowClose } from 'react-icons/fa'

const Skills = (props) => {
    const [tags, setTags] = React.useState(props.state[0]);
    const removeTags = indexToRemove => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    }
    const addTags = event => {
        if (event.target.value !== "") {
            setTags([...tags, event.target.value]);
            event.target.value = "";
        }
    };
    // console.log(tags);

    useEffect(() => {
        setTags(props.state[0])
    }, [props.state])

    useEffect(() => {
        props.state[1]({ skills: tags })
    }, [tags])

    return (
        // <Form>


        // </Form>
        <div>
            <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>Type Your skills and press Enter !!!</Form.Label>

                <Form.Control type="text" required placeholder="eg. Press Enter" onKeyUp={e => e.key === "Enter" ? addTags(e) : null} />
                <ul className="tagsContainer">
                    {tags.map((tag, index) =>
                        <li key={index} className="badge badge-primary single">
                            <span>{tag}</span> &nbsp; <FaWindowClose onClick={() => removeTags(index)} />
                        </li>
                    )}
                </ul>
            </Form.Group>


        </div>
    )
}

export default Skills;